import { render, staticRenderFns } from "./ComingSoonModal.vue?vue&type=template&id=88e9f33c&scoped=true"
import script from "./ComingSoonModal.vue?vue&type=script&lang=js"
export * from "./ComingSoonModal.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonModal.vue?vue&type=style&index=0&id=88e9f33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e9f33c",
  null
  
)

export default component.exports